(function () {
  'use strict';

  var STORAGE_KEY = 'dd_selected_products';
  var PANEL_STORAGE_KEY = 'dd_selected_products_panel_open';

  function getRoot() {
    return document.querySelector('[data-dd-selected-products]');
  }

  function getConfig() {
    var root = getRoot();

    if (!root || root.dataset.enabled !== 'true') {
      return null;
    }

    return {
      root: root,
      maxProducts: parseInt(root.dataset.maxProducts || '10', 10),
      whatsappNumber: root.dataset.whatsappNumber || '',
      checkboxLabel: root.dataset.checkboxLabel || 'Ask Our Team',
      barLabel: root.dataset.barLabel || 'selected',
      barButton: root.dataset.barButton || 'Ask our team',
      viewItemsText: root.dataset.viewItemsText || 'View items',
      clearText: root.dataset.clearText || 'Clear',
      modalTitle: root.dataset.modalTitle || 'Ask our team',
      modalDescription: root.dataset.modalDescription || '',
      selectedTitle: root.dataset.selectedTitle || 'Your selected pieces',
      removeText: root.dataset.removeText || 'Remove',
      viewProductText: root.dataset.viewProductText || 'View product ↗',
      helpTitle: root.dataset.helpTitle || 'How can we help?',
      helpOptionalText: root.dataset.helpOptionalText || 'Optional',
      helpPlaceholder: root.dataset.helpPlaceholder || '',
      whatsappButtonText: root.dataset.whatsappButtonText || 'Continue to WhatsApp',
      messageFooterText: root.dataset.messageFooterText || 'Your message will be included on WhatsApp.',
      messagePrefix: root.dataset.messagePrefix || 'Hi, I would like help with these selected products:',
      messageProductLine: root.dataset.messageProductLine || '• {title} | SKU: {sku} | {price} | {url}'
    };
  }

  function readSelected() {
    try {
      var data = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function writeSelected(items) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );
  }

  function readPanelState() {
    return localStorage.getItem(
      PANEL_STORAGE_KEY
    ) !== 'false';
  }

  function writePanelState(isOpen) {
    localStorage.setItem(
      PANEL_STORAGE_KEY,
      isOpen ? 'true' : 'false'
    );
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProductFromCheckbox(checkbox) {
    return {
      id: checkbox.dataset.productId || '',
      variantId: checkbox.dataset.productVariantId || '',
      title: checkbox.dataset.productTitle || '',
      sku: checkbox.dataset.productSku || '',
      price: checkbox.dataset.productPrice || '',
      url: checkbox.dataset.productUrl || '',
      image: checkbox.dataset.productImage || '',
      available: checkbox.dataset.productAvailable === 'true'
    };
  }

  function updateSelectionLabels(config) {
    document
      .querySelectorAll('[data-dd-selection-label]')
      .forEach(function (label) {
        label.textContent = config.checkboxLabel;
      });
  }

  function syncCheckboxes(selected) {
    var selectedIds = selected.map(function (item) {
      return String(item.id);
    });

    document
      .querySelectorAll('.dd-product-select__checkbox')
      .forEach(function (checkbox) {
        checkbox.checked =
          selectedIds.indexOf(
            String(
              checkbox.dataset.productId || ''
            )
          ) !== -1;
      });
  }

  function renderPreview(config, selected) {
    var preview = config.root.querySelector(
      '[data-dd-selected-preview]'
    );

    if (!preview) {
      return;
    }

    preview.innerHTML = selected
      .slice(-3)
      .map(function (item) {
        return (
          '<div class="dd-selected-products__preview-item">' +
            '<img src="' +
              escapeHtml(item.image) +
              '" alt="' +
              escapeHtml(item.title) +
            '">' +
          '</div>'
        );
      })
      .join('');
  }

  function renderList(config, selected) {
    var list = config.root.querySelector(
      '[data-dd-selected-list]'
    );

    if (!list) {
      return;
    }

    list.innerHTML = selected
      .map(function (item) {
        return '' +
          '<div class="dd-selected-products__item" data-dd-selected-item="' +
            escapeHtml(item.id) +
          '">' +

            '<div class="dd-selected-products__item-image">' +
              '<img src="' +
                escapeHtml(item.image) +
                '" alt="' +
                escapeHtml(item.title) +
                '" loading="lazy">' +
            '</div>' +

            '<div class="dd-selected-products__item-info">' +

              '<div class="dd-selected-products__item-title">' +
                escapeHtml(item.title) +
              '</div>' +

              (
                item.sku
                  ? '<div class="dd-selected-products__item-sku">' +
                      'SKU: ' +
                      escapeHtml(item.sku) +
                    '</div>'
                  : ''
              ) +

              (
                item.price
                  ? '<div class="dd-selected-products__item-price">' +
                      escapeHtml(item.price) +
                    '</div>'
                  : ''
              ) +

              '<div class="dd-selected-products__item-links">' +
                '<a href="' +
                  escapeHtml(item.url) +
                  '" target="_blank">' +
                  escapeHtml(config.viewProductText) +
                '</a>' +
              '</div>' +

            '</div>' +

            '<button ' +
              'type="button" ' +
              'class="dd-selected-products__item-remove" ' +
              'data-dd-remove-product="' +
                escapeHtml(item.id) +
              '">' +
              escapeHtml(config.removeText) +
            '</button>' +

          '</div>';
      })
      .join('');
  }

  function setPanelOpen(config, isOpen) {
    var bar = config.root.querySelector(
      '[data-dd-selected-bar]'
    );

    if (!bar) {
      return;
    }

    bar.classList.toggle(
      'dd-panel-open',
      isOpen
    );

    bar.classList.toggle(
      'dd-panel-closed',
      !isOpen
    );

    writePanelState(isOpen);
  }

  function render(config) {
    var selected = readSelected();

    var bar = config.root.querySelector(
      '[data-dd-selected-bar]'
    );

    var count = config.root.querySelector(
      '[data-dd-selected-count]'
    );

    var modalCount = config.root.querySelector(
      '[data-dd-modal-count]'
    );

    var selectedTitle = config.root.querySelector(
      '[data-dd-selected-title]'
    );

    var barLabel = config.root.querySelector(
      '[data-dd-bar-label]'
    );

    var barButton = config.root.querySelector(
      '[data-dd-bar-button]'
    );

    var viewItems = config.root.querySelector(
      '[data-dd-view-items]'
    );

    var clearButton = config.root.querySelector(
      '[data-dd-clear]'
    );

    if (bar) {
      bar.hidden = selected.length === 0;

      if (selected.length) {
        setPanelOpen(
          config,
          readPanelState()
        );
      }
    }

    if (count) {
      count.textContent = selected.length;
    }

    if (modalCount) {
      modalCount.textContent = selected.length;
    }

    if (selectedTitle) {
      selectedTitle.textContent =
        config.selectedTitle;
    }

    if (barLabel) {
      barLabel.textContent =
        config.barLabel;
    }

    if (barButton) {
      barButton.textContent =
        config.barButton;
    }

    if (viewItems) {
      viewItems.textContent =
        config.viewItemsText;
    }

    if (clearButton) {
      clearButton.textContent =
        config.clearText;
    }

    renderPreview(
      config,
      selected
    );

    renderList(
      config,
      selected
    );

    syncCheckboxes(
      selected
    );

    updateSelectionLabels(
      config
    );
  }

  function openModal(config) {
    if (!config) {
      return;
    }

    var modalWrap =
      config.root.querySelector(
        '[data-dd-modal-wrap]'
      );

    var modal =
      config.root.querySelector(
        '[data-dd-modal]'
      );

    if (
      !modalWrap ||
      !readSelected().length
    ) {
      return;
    }

    render(config);

    modalWrap.hidden = false;

    document.documentElement.classList.add(
      'dd-selected-products-open'
    );

    document.body.classList.add(
      'dd-selected-products-open'
    );

    window.setTimeout(function () {
      if (modal) {
        modal.focus();
      }
    }, 0);
  }

  function closeModal(config) {
    if (!config) {
      return;
    }

    var modalWrap =
      config.root.querySelector(
        '[data-dd-modal-wrap]'
      );

    if (!modalWrap) {
      return;
    }

    modalWrap.hidden = true;

    document.documentElement.classList.remove(
      'dd-selected-products-open'
    );

    document.body.classList.remove(
      'dd-selected-products-open'
    );
  }

  function removeProduct(productId) {
    var selected =
      readSelected().filter(function (item) {
        return String(item.id) !==
          String(productId);
      });

    writeSelected(selected);

    var config = getConfig();

    if (config) {
      render(config);
    }
  }

  function clearProducts() {
    writeSelected([]);

    writePanelState(false);

    var config = getConfig();

    if (config) {
      closeModal(config);
      render(config);
    }
  }

  function buildWhatsAppMessage(
    config,
    selected,
    customMessage
  ) {
    var message =
      config.messagePrefix;

    selected.forEach(function (item) {
      var line =
        config.messageProductLine
          .replace(
            /\{title\}/g,
            item.title || ''
          )
          .replace(
            /\{sku\}/g,
            item.sku || ''
          )
          .replace(
            /\{price\}/g,
            item.price || ''
          )
          .replace(
            /\{url\}/g,
            window.location.origin +
              (item.url || '')
          );

      message += '\n' + line;
    });

    if (customMessage.trim()) {
      message +=
        '\n\n' +
        customMessage.trim();
    }

    return message;
  }

  function sendToWhatsApp(config) {
    var selected = readSelected();

    if (!selected.length) {
      return;
    }

    var number =
      (config.whatsappNumber || '')
        .replace(/\D/g, '');

    if (!number) {
      window.alert(
        'WhatsApp number is not configured.'
      );

      return;
    }

    var messageField =
      config.root.querySelector(
        '[data-dd-message]'
      );

    var customMessage =
      messageField
        ? messageField.value
        : '';

    var message =
      buildWhatsAppMessage(
        config,
        selected,
        customMessage
      );

    var whatsappUrl =
      'https://wa.me/' +
      number +
      '?text=' +
      encodeURIComponent(message);

    window.open(
      whatsappUrl,
      '_blank',
      'noopener,noreferrer'
    );
  }

  window.ddSelectedProductsToggle =
    function (checkbox) {
      var config = getConfig();

      if (!config || !checkbox) {
        return;
      }

      var selected =
        readSelected();

      var productId =
        String(
          checkbox.dataset.productId || ''
        );

      if (!productId) {
        return;
      }

      if (checkbox.checked) {
        if (
          selected.some(function (item) {
            return String(item.id) ===
              productId;
          })
        ) {
          setPanelOpen(
            config,
            true
          );

          render(config);

          return;
        }

        if (
          selected.length >=
          config.maxProducts
        ) {
          checkbox.checked = false;

          window.alert(
            'You can select up to ' +
            config.maxProducts +
            ' products.'
          );

          return;
        }

        selected.push(
          getProductFromCheckbox(
            checkbox
          )
        );

        writeSelected(
          selected
        );

        setPanelOpen(
          config,
          true
        );

        render(config);

        return;
      }

      selected =
        selected.filter(function (item) {
          return String(item.id) !==
            productId;
        });

      writeSelected(
        selected
      );

      if (!selected.length) {
        setPanelOpen(
          config,
          false
        );
      }

      render(config);
    };

  function bind(config) {
    if (
      !config ||
      config.root.dataset.ddBound === 'true'
    ) {
      return;
    }

    config.root.dataset.ddBound = 'true';

    config.root.addEventListener(
      'click',
      function (event) {
        var panelCloseButton =
          event.target.closest(
            '[data-dd-panel-close]'
          );

        var panelOpenButton =
          event.target.closest(
            '[data-dd-panel-open]'
          );

        var openButton =
          event.target.closest(
            '[data-dd-open-modal]'
          );

        var closeButton =
          event.target.closest(
            '[data-dd-close-modal]'
          );

        var removeButton =
          event.target.closest(
            '[data-dd-remove-product]'
          );

        var whatsappButton =
          event.target.closest(
            '[data-dd-whatsapp]'
          );

        var clearButton =
          event.target.closest(
            '[data-dd-clear]'
          );

        if (panelCloseButton) {
          event.preventDefault();
          event.stopPropagation();

          setPanelOpen(
            config,
            false
          );

          return;
        }

        if (panelOpenButton) {
          event.preventDefault();
          event.stopPropagation();

          setPanelOpen(
            config,
            true
          );

          return;
        }

        if (openButton) {
          event.preventDefault();

          setPanelOpen(
            config,
            true
          );

          openModal(
            config
          );

          return;
        }

        if (closeButton) {
          event.preventDefault();

          closeModal(
            config
          );

          return;
        }

        if (removeButton) {
          event.preventDefault();

          removeProduct(
            removeButton.dataset
              .ddRemoveProduct
          );

          return;
        }

        if (clearButton) {
          event.preventDefault();

          clearProducts();

          return;
        }

        if (whatsappButton) {
          event.preventDefault();

          sendToWhatsApp(
            config
          );
        }
      }
    );

    var messageField =
      config.root.querySelector(
        '[data-dd-message]'
      );

    if (messageField) {
      messageField.addEventListener(
        'input',
        function () {
          var counter =
            config.root.querySelector(
              '[data-dd-message-count]'
            );

          if (counter) {
            counter.textContent =
              messageField.value.length;
          }
        }
      );
    }

    render(config);
  }

  function init() {
    var config = getConfig();

    if (!config) {
      return;
    }

    bind(config);

    render(config);
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') {
        return;
      }

      var config = getConfig();

      if (config) {
        closeModal(config);
      }
    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    init
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      init();
    }
  );

  window.addEventListener(
    'pageshow',
    function () {
      init();
    }
  );

  window.addEventListener(
    'storage',
    function (event) {
      if (
        event.key !== STORAGE_KEY
      ) {
        return;
      }

      var config = getConfig();

      if (config) {
        render(config);
      }
    }
  );

})(); 